import { LineWave } from 'react-loader-spinner';

const ThreeDotLoader = () => (
  // <Loader
  //   type='ThreeDots'
  //   height='17'
  //   width='35'
  //   radius={9}
  //   color='#fff'
  //   visible={true}
  // />
  <LineWave
    height={17}
    width={35}
    color='#fff'
    ariaLabel='line-wave'
    wrapperStyle={{}}
    wrapperClass=''
    visible={true}
  />
);

export default ThreeDotLoader;
